// This function allow to reference async chunks
__webpack_require__.miniCssF = function(chunkId) {
	// return url for filenames based on template
	return "static/css/" + chunkId + "." + {"48":"760e25ee","428":"e689a888","546":"b0911e2f","577":"ad168374","757":"41186560"}[chunkId] + ".chunk.css";
};